<html>

    <body class="dx-viewport">
       
        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->  
        <dx-box
            direction="row"
            width="100%"
            [height]="formheight"
        >
            <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
            <dxi-item
                [ratio]="1.0"
            >
                
                <dx-data-grid 
                    #grideventgift
                    id="grideventgift"

                    keyExpr="id"
                    [dataSource]="subscriptiongiftlist"    

                    [allowColumnReordering]="false"
                    [allowColumnResizing]="true"
                    [showRowLines]="true"
                    [showColumnLines]="false"
                    [showBorders]="true"
                    [repaintChangesOnly]="true"

                    [focusedRowEnabled]="true"
                    [hoverStateEnabled]="true"
                    [autoNavigateToFocusedRow]="true"

                    width="100%"
                    height="98%"

                    (onRowClick)="onrowclick($event)"
                    (onFocusedRowChanged)="onrowchange($event)"

                    (onCellPrepared)="editorPreparing( $event )" 

                >
                    <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                    <dxo-filter-row
                        [visible]="true"
                    ></dxo-filter-row>
                    
                    <dxo-sorting
                        mode="single"> <!-- or "multiple" | "none" -->
                    </dxo-sorting>

                    <dxo-selection
                        mode="single"
                    >
                    </dxo-selection>

                    <dxo-load-panel
                        [enabled]="false">
                    </dxo-load-panel>

                    <dxo-editing 
                        mode="popup"                            
                        [allowUpdating]="true"
                        [allowDeleting]="true"
                        [allowAdding]="true"
                        [useIcons]="true"
                    >
                    </dxo-editing>
                    <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                    <dxi-column
                        dataField="id"
                        caption="id"
                        [allowEditing]="false" 
                        [allowSorting]="false"
                        [visible]="false"
                        width="19%"
                    >
                    </dxi-column>   

                    <dxi-column
                        dataField="giftdescription"
                        caption="Gift Description"
                        [allowEditing]="true" 
                        [allowSorting]="false"
                        [visible]="true"
                        width="19%"
                    >

                        <dxi-validation-rule 
                            type="required"
                            message="Please enter Gift Description">
                        </dxi-validation-rule>

                    </dxi-column> 
                    
                    <dxi-column
                        dataField="brand"
                        caption="Brand"
                        [allowEditing]="true" 
                        [allowSorting]="false"
                        [visible]="true"
                        width="19%"
                    >

                    </dxi-column> 

                    <dxi-column
                        dataField="sourceoption"
                        caption="Where to Buy"
                        [allowEditing]="true" 
                        [allowSorting]="false"
                        [visible]="true"
                        width="19%"
                    >
                    </dxi-column> 

                    <dxi-column
                        dataField="giftlist"
                        caption="Register"
                        [allowEditing]="true" 
                        [allowSorting]="false"
                        [visible]="true"
                        width="19%"

                        cellTemplate="cellregisterassign"
                    >
                        
                        <div *dxTemplate="let data of 'cellregisterassign'">

                            <container-element [ngSwitch]="data.value">
                                <div *ngSwitchCase="true"><i class="fa-solid fa-circle-check fa-2x center"></i></div>
                                <div *ngSwitchCase="false"><i class="fa-solid fa-circle-xmark fa-2x center"></i></div>
                            </container-element>
                            
                        </div>

                    </dxi-column> 

                    <dxi-column
                        dataField="giftassign"
                        caption="Gift Assign"
                        [allowEditing]="true" 
                        [allowSorting]="false"
                        [visible]="true"
                        width="15%"

                        cellTemplate="cellgiftassign"
                    >


                        <div *dxTemplate="let data of 'cellgiftassign'">

                            <container-element [ngSwitch]="data.value">
                                <div *ngSwitchCase="true"><i class="fa-solid fa-circle-check fa-2x center"></i></div>
                                <div *ngSwitchCase="false"><i class="fa-solid fa-circle-xmark fa-2x center"></i></div>
                            </container-element>
                            
                        </div>

                </dxi-column>
                    <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                    <dxo-toolbar>
                        <dxi-item location="after">
                            <div *dxTemplate>

                                <dx-button
                                    text="Add"
                                    icon="refresh" 
                                    (onClick)="giftform( $event, 10)"
                                >

                                </dx-button>

                                <dx-button
                                    text="Edit"
                                    icon="refresh"  
                                    [disabled]="buttondisable"
                                    (onClick)="giftform( $event, 20)"
                                >

                                </dx-button>

                            </div>
                        </dxi-item>
                    </dxo-toolbar>


                </dx-data-grid>


            </dxi-item>
            <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
        </dx-box>
        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
        <dx-popup
            [(title)] = "popuptitle"
            [hideOnOutsideClick]="true"
            [(visible)]="popupgiftVisible"
            height="80%"
            width="50%"
        >
            <!------------------------------------------------------------------------->
            <dxi-toolbar-item
                widget="dxButton"
                location="after"
                toolbar="bottom"

                [options]="{
                                text: 'Save',
                                type: 'success',
                                onClick: saveClick
                            }"

            >
            </dxi-toolbar-item>

            <dxi-toolbar-item
                widget="dxButton"
                location="after"
                toolbar="bottom"

                [options]="{
                                text: 'Cancel',
                                onClick: cancelClick
                            }"

            >
            </dxi-toolbar-item>
            <!------------------------------------------------------------------------->
            <dxo-position

                my="left"
                at="right"
                of="#grideventgift"    
            >
                <dxo-offset 
                    [x]="10" 
                    [y]="-105">
                </dxo-offset>

            </dxo-position>
            <!------------------------------------------------------------------------->
            <div *dxTemplate="let data of 'content'">
                <!------------------------------------------------------------------------->
                <dx-form 
                    #formgift
                    [(formData)]="formData"
                    
                    [showColonAfterLabel]="true"  
                    labelMode="outside"
                    labelLocation="left"

                    (onFieldDataChanged)="formDatafldchange( $event )"

                    [colCount]="1"
                >
                    <dxi-item 
                        itemType="group" 
                        caption="Gift Profile"
                        [colCount]="1"

                    >

                        <dxi-item
                            dataField="giftdescription"
                    
                            [editorOptions]="{  width: 250, 
                                                height: 40, 
                                                placeholder: 'Enter Gift Details', 
                                                inputAttr: { autocomplete: 'chrome-off'}
                                            }"
                        >

                            <dxo-label 
                                template="name"
                                text="Gift Details"
                            >
                            </dxo-label>                 

                            <dxi-validation-rule 
                                type="required"
                                message="Gift Details is required"
                            >
                            </dxi-validation-rule>

                        </dxi-item>

                        <dxi-item
                            dataField="brand"
                    
                            [editorOptions]="{  width: 250, 
                                                height: 40, 
                                                placeholder: 'Enter Brand Details', 
                                                inputAttr: { autocomplete: 'chrome-off'}
                                            }"
                        >

                            <dxo-label 
                                template="name"
                                text="Brand Details"
                            >
                            </dxo-label>                

                        </dxi-item>

                        <dxi-item
                            dataField="sourceoption"
                    
                            [editorOptions]="{  width: 250, 
                                                height: 40, 
                                                placeholder: 'Enter where can you get it', 
                                                inputAttr: { autocomplete: 'chrome-off'}
                                            }"
                        >

                            <dxo-label 
                                template="name"
                                text="Get it Where"
                            >
                            </dxo-label>                

                        </dxi-item>

                        <dxi-item
                            dataField="giftlist"
                            editorType="dxCheckBox"
                    
                            [editorOptions]="{  width: 250, 
                                                height: 20, 
                                                placeholder: 'Is Gift part of Register', 
                                                inputAttr: { autocomplete: 'chrome-off'}
                                            }"
                        >

                            <dxo-label 
                                template="name"
                                text="Gift Register"
                            >
                            </dxo-label>                

                        </dxi-item>

                        <dxi-item
                            dataField="notes"
                            editorType="dxTextArea"

                            [editorOptions]="{  width: 250, 
                                                height: 140, 
                                                placeholder: 'Enter Gift Notes', 
                                                inputAttr: { autocomplete: 'chrome-off'}
                                            }"

                        >
                            <dxo-label 
                                template="note"
                                text="Notes"
                            >
                            </dxo-label>    
                        </dxi-item>

                    </dxi-item>

                     <!------------------------------------------------------------------------->
                     <ng-container *ngFor="let label of labelTemplates">
                        <div *dxTemplate="let data of label.name">
                          <div><i class="dx-icon {{ label.icon }}"></i>{{ data.text }}</div>
                        </div>
                    </ng-container>
                    <!------------------------------------------------------------------------->
            
                </dx-form>
                <!------------------------------------------------------------------------->
            </div>
            <!------------------------------------------------------------------------->
        </dx-popup>
        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
    </body>

</html>

